import { Button, Text } from '@chakra-ui/react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { Location } from 'history';
import { TFunction } from 'i18next';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Error from '../../../core/components/Error/Error';
import { Icon } from '../../../core/components/Icon/Icon';
import { commonConfig } from '../../../core/config';

export interface NotSupportedProps {
  redirectUrl?: Location | { pathname: string };
}

export const notSupportedDescription = (t: TFunction): React.ReactNode => (
  <>
    {t('error.notSupportedDescription')}
    <div>
      <a href={commonConfig.links.chrome} target="_blank" rel="nofollow noopener noreferrer">
        Google Chrome
      </a>
      <span> / </span>
      <a href={commonConfig.links.firefox} target="_blank" rel="nofollow noopener noreferrer">
        Mozilla Firefox
      </a>
      <span> / </span>
      <a href={commonConfig.links.edge} target="_blank" rel="nofollow noopener noreferrer">
        Microsoft Edge
      </a>
    </div>
  </>
);

const NotSupported = ({ redirectUrl }: NotSupportedProps): React.ReactElement | null => {
  const { t } = useTranslation();
  return (
    <Error
      title={t('error.notSupportedTitle')}
      description={notSupportedDescription(t)}
      logo
      homeButton
      actions={
        redirectUrl ? (
          <Link to={redirectUrl} className="none">
            <Button size="sm" rightIcon={<Icon icon={faChevronRight} />}>
              <Text as="span" mr={1}>
                {t('global.continueAnyway')}
              </Text>
            </Button>
          </Link>
        ) : null
      }
    />
  );
};

export default NotSupported;
